import SelectButtonField from './SelectButtonField'
import { withSelectButtonField } from './withSelectButtonField'

const ConnectedSelectButtonField = withSelectButtonField(SelectButtonField)

export { ConnectedSelectButtonField as SelectButtonField }
